export default __webpack_public_path__ + "static/char-s-62-jp-1b3df7c2782c9bc2d96973b47964cf10.png";